<template>
  <v-col
    :cols="block.cols"
    :xs="block.colsxs"
    :sm="block.colssm"
    :md="block.colsmd"
    :lg="block.colslg"
    :xl="block.colsxl"
    :offset="block.offset"
    :class="block.class + ' px-0'"
  >
    <v-expansion-panels v-model="panel" class="px-0" flat>
      <v-expansion-panel>
        <v-expansion-panel-header
          :class="
            panel !== undefined
              ? 'primary--text font-weight-bold'
              : ' grey--text text--darken-3 font-weight-bold'
          "
          style="font-size: 18px !important"
        >
          <template #actions>
            <v-icon large class="expansionpanel-icon" color="primary">
              mdi-chevron-down-circle
            </v-icon>
          </template>
          <span class="expansionpanel-header">
            {{ block.label }}

          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="ml-10">
          <v-row>
            <template v-for="expansionBlock in block.expansionComponents">
              <component
                :is="expansionBlock.component"
                :key="expansionBlock.uid"
                v-model="form[expansionBlock.uid]"
                :block="expansionBlock"
              />
            </template>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-col>
</template>

<script>
export default {
   name: 'Expansionpanel',
   model: {
      prop: 'form',
      event: 'update:form',
   },

   props: {
      block: {
         type: Object,
         required: true,
      },
      form: {
         type: Object,
         required: true,
      },
   },

   data () {
      return {
         panel: undefined,
         show: false,
      }
   },
   computed: {
      icon () {
         return this.form[this.block.checkbox] ? 'mdi-minus' : 'mdi-plus'
      },
   },

   watch: {
      form: {
         deep: true,
         handler (val, oldVal) {
            this.$emit('update:form', this.form)
         },
      },
   },

   created () {
      for (const optionalKey in this.form) {
         console.log(optionalKey)
         if (
            optionalKey[optionalKey] !== null &&
        optionalKey[optionalKey] !== undefined
         ) {
            this.show = true
         }
      }
   },
}
</script>
